// eslint-disable-next-line import/no-unresolved
import { Dimensions } from "react-native";

const { width: Dwidth, height } = Dimensions.get("window");

/**
 * this function converts regular react native pixel to
 * device relative pxiel size based on horizontal width
 * so all devices will have same output
 */

const ratio = height / Dwidth;
const baseRatio = 1.7786666666666;
const baseWidth = 394;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function px(pixelSize = 1) {
  return (((ratio / baseRatio) * Dwidth) / baseWidth) * pixelSize;
}
